export const REQUEST_BOARD_COLUMN_CARDS_MORE_SKELETON_CARDS = ['more']
